import {Error, ErrorType} from 'mw/api/Error';

export function validatePIN(pin: string): void {
  if (!pin.match(/^\d{4}$/)) {
    throw new Error(ErrorType.ProfilePINTooShort);
  }
}
